var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap_pageCards"},_vm._l((_vm.columnComponents),function(columnComponent,columnIndex){return _c('div',{key:`${_vm.preKey}_${columnIndex}`},[_c(columnComponent.component,{tag:"component",attrs:{"params":columnComponent.params,"language":_vm.language},on:{"readMore":_vm.readMore}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }